import useLayeredContent from './useLayeredContent'
import type { VendorList } from '../../utils/vendors-config'

export function useContentVendorList() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getVendorLists() {
        return await queryAll<VendorList>('vendors/lists')
    }

    async function getVendorListBySlug(slug: string) {
        return await queryBySlug<VendorList>('vendors/lists', slug)
    }

    return { getVendorLists, getVendorListBySlug }
}
